import { gql, useMutation } from '@apollo/client';
import { User, USER_FIELDS } from './useUserQuery';

const SWITCH_TENANT = gql`
  ${USER_FIELDS}
  mutation SwitchTenant($companyId: String!) {
    switchTenant(companyId: $companyId) {
      ...UserFields
    }
  }
`;

export interface SwitchTenantInput {
  companyId: string;
}

export interface SwitchTenantResult {
  switchTenant: User;
}

export function useSwitchTenantMutation() {
  return useMutation<SwitchTenantResult, SwitchTenantInput>(SWITCH_TENANT, {
    refetchQueries: ['GetUser', 'GetTasks'],
    update(cache, { data }) {
      // Update the user in cache
      cache.modify({
        fields: {
          getUser: () => data?.switchTenant || null,
        },
      });

      // Evict all tenant-specific queries to force refetch with new company ID
      cache.evict({ fieldName: 'getTopics' });
      cache.evict({ fieldName: 'getCompany' });
      cache.evict({ fieldName: 'getUserValues' });
      cache.evict({ fieldName: 'getTasks' });
      cache.gc();
    },
  });
}
